/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Notfound_TitleInputs */

const en_common_notfound_title = /** @type {(inputs: Common_Notfound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const zh_common_notfound_title = /** @type {(inputs: Common_Notfound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面不存在`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Common_Notfound_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_notfound_title = /** @type {((inputs?: Common_Notfound_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Notfound_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_notfound_title(inputs)
	return zh_common_notfound_title(inputs)
});
export { common_notfound_title as "common.notfound.title" }